import { Form as AntdForm, Select, Input } from 'antd'
import Flex from 'components/Flex'
import SelectArrowIcon from 'components/icons/SelectArrowIcon'
import React, { useMemo, useState } from 'react'
import styled from 'styled-components'

import InputText from 'components/Form/InputText'
import Label from './Label'
export const FormItem = styled(AntdForm.Item)`
  margin-bottom: ${props =>
    props.marginbottom ? props.marginbottom : '0px'} !important;
  width: 100%;
  .ant-form-item-explain-error {
    padding-left: ${props => (props.padding ? '15%' : '0')};
  }
`

const StyledSelect = styled(Select)`
  width: 100% !important;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #010e30;

  .ant-select-selector {
    background-color: ${props =>
      !props.disabled
        ? props.backgroundcolor
          ? '#fafafb'
          : '#ffffff'
        : '#f5f5f5'} !important;
    border-radius: 8px !important;
    border-color: #e9e9e9 !important;
    box-shadow: none !important;
  }
  .ant-select-selection-item {
    background-color: ${props =>
      !props.disabled
        ? props?.mode === 'multiple' || props?.mode === 'tags'
          ? '#ebecee'
          : '#ffffff'
        : '#f5f5f5'};
    border-radius: 6px;
    color: ${props => !props.disabled && '#010e30'};
  }
  .ant-select-multiple.ant-select-lg .ant-select-selection-item {
    background-color: ${props =>
      !props.disabled
        ? props?.mode === 'multiple' || props?.mode === 'tags'
          ? '#ebecee'
          : '#ffffff'
        : '#f5f5f5'};
  }
  :hover {
    border-radius: 6px;
    color: #010e30;
  }
  .ant-select-dropdown-placement-bottomLeft {
    width: 1000px !important;
  }
  .ant-select-selection-item-remove {
    display: flex;
    align-items: center;
  }
  .ant-select-selection-placeholder {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
  }
`

const OTHERS_KEY = 'Others'

const DropDown = ({
  options = [],
  value,
  onChange,
  width = '100%',
  error,
  name,
  label,
  placeholder,
  optional = false,
  required = false,
  valueParam = 'id',
  nameParam = 'name',
  isOthers = false,
  position = 'relative',
  otherPlaceholder,
  otherLabel,
  isCombined = false,
  loading,
  id = 'select',
  onSearch,
  isFilterOption = true,
  ...rest
}) => {
  const [showCustomInput, setShowCustomInput] = useState(false)
  const handleSelectChange = (val, option) => {
    if (val === OTHERS_KEY) {
      setShowCustomInput(true)
      onChange('', { isOthers: true })
    } else {
      setShowCustomInput(false)
      onChange(val, option)
    }
  }

  const handleMultiSelectChange = (val, optionList) => {
    const selectedPayloads = optionList
      .map(opt => opt?.props?.option)
      .filter(Boolean)
    onChange(val, selectedPayloads)
  }

  const filterOption = (input, option) => {
    if (!input) return
    const match = (options || []).some(opt =>
      String(opt[nameParam]).toLowerCase().includes(input.toLowerCase())
    )
    if (!match && isOthers) {
      return option.value === OTHERS_KEY
    }
    return String(option.children).toLowerCase().includes(input.toLowerCase())
  }

  const handleCustomInputChange = e => {
    const inputVal = e.target.value
    onChange(inputVal, { isOthers: true })
  }

  // const combinedOptions = useMemo(() => {
  //   const validOptions = (options || []).filter(
  //     opt => opt[valueParam] !== null && opt[valueParam] !== undefined
  //   )
  //   return isOthers
  //     ? [...validOptions, { [valueParam]: OTHERS_KEY, [nameParam]: 'Others' }]
  //     : validOptions
  // }, [options, isOthers, valueParam, nameParam])
  const combinedOptions = useMemo(() => {
    const validOptions = (options || []).filter(
      opt => opt[valueParam] !== null && opt[valueParam] !== undefined
    )
    const mapped = validOptions.map(opt => ({
      label: opt[nameParam], // what is shown in dropdown
      value: opt[valueParam], // what is used as value
      ...opt, // keep the original fields if needed
    }))
    return isOthers
      ? [...mapped, { label: 'Others', value: OTHERS_KEY }]
      : mapped
  }, [options, isOthers, valueParam, nameParam])

  return (
    <div name={name} key={name}>
      <Flex id={id} column style={{ width, position, gap: '0.5rem' }}>
        {label && (
          <Label required={required}>
            {label} <span>{optional}</span>
          </Label>
        )}
        <StyledSelect
          width={width}
          name={name}
          size="large"
          suffixIcon={<SelectArrowIcon />}
          placeholder={placeholder}
          filterOption={isFilterOption ? filterOption : false}
          getPopupContainer={() => document.getElementById(`${id}`)}
          onChange={isCombined ? handleMultiSelectChange : handleSelectChange}
          value={
            showCustomInput ? OTHERS_KEY : value !== '' ? value : undefined
          }
          options={combinedOptions}
          loading={loading}
          onSearch={onSearch}
          {...rest}
        >
          {/* {combinedOptions.map(option => (
            <Select.Option
              key={option[valueParam]}
              value={option[valueParam]}
              option={option?.payload ?? option}
              formName={name}
              style={{ padding: '10px 12px' }}
            >
              {option[nameParam]}
            </Select.Option>
          ))} */}
        </StyledSelect>

        {showCustomInput && (
          <InputText
            onChange={handleCustomInputChange}
            style={{ marginTop: '8px' }}
            placeholder={otherPlaceholder}
            label={otherLabel}
          />
        )}

        {error && (
          <span style={{ color: 'red', fontSize: '12px' }}>{error}</span>
        )}
      </Flex>
    </div>
  )
}

export default DropDown
